import React from 'react';
import GridRowContainer from 'shared/lib/extendedComponents/grids/components/gridRowContainer';
import DesktopSettingsCell from 'shared/lib/extendedComponents/grids/components/settingsCell/desktopSettingsCell';
import TextCell from 'shared/lib/extendedComponents/grids/components/textCell';
import ItemFormatCell, {
  SpecialTypes,
} from 'shared/lib/extendedComponents/grids/components/itemFormatCell';
import { observer } from 'mobx-react-lite';
import DesktopTableNameCell from 'shared/lib/extendedComponents/grids/components/tableNameCell/desktopTableNameCell';
import MobileTableNameCell from 'shared/lib/extendedComponents/grids/components/tableNameCell/mobileTableNameCell';
import MobileSettingsCell from 'shared/lib/extendedComponents/grids/components/settingsCell/mobileSettingsCell';
import { ExplorerEntityTypes, ContentTableItem } from 'entities/types';
import { useBooleanScreens } from 'shared/hooks/useBooleanScreens';
import { DateManager } from 'shared/lib/utils/dateManager';
import { noValue } from 'shared/lib/utils/uiConstants';

export default observer(function ContentTableRow({
  onClick,
  onFavorite,
  onEdit,
  onDownload,
  onRestore,
  onDelete,
  supportTypes,
  data,
}: {
  onClick?: () => void;
  onEdit?: () => void;
  onFavorite?: () => void;
  onDownload?: () => void;
  onRestore?: () => void;
  onDelete?: () => void;
  supportTypes: ExplorerEntityTypes[];
  data: ContentTableItem;
}) {
  const { isLessLaptop } = useBooleanScreens();

  return isLessLaptop ? (
    <GridRowContainer onClick={onClick}>
      <MobileTableNameCell
        name={data.name}
        updatedAt={data.last_change_date}
      ></MobileTableNameCell>
      <MobileSettingsCell
        onEdit={onEdit}
        onDownload={onDownload}
        onRestore={onRestore}
        onDelete={onDelete}
        onFavorite={onFavorite}
        isFavorite={data.is_favorite}
      ></MobileSettingsCell>
    </GridRowContainer>
  ) : (
    <GridRowContainer onClick={onClick}>
      <DesktopTableNameCell
        name={data.name}
        lastChangeAuthor={data.username}
      ></DesktopTableNameCell>
      <TextCell>{new DateManager(data.last_change_date).frontFormat}</TextCell>
      <ItemFormatCell format={SpecialTypes.TABLE}></ItemFormatCell>
      {supportTypes.includes(ExplorerEntityTypes.FILE) ? (
        <TextCell>{noValue}</TextCell>
      ) : null}
      <DesktopSettingsCell
        onEdit={onEdit}
        onDownload={onDownload}
        onRestore={onRestore}
        onDelete={onDelete}
        onFavorite={onFavorite}
        isFavorite={data.is_favorite}
      ></DesktopSettingsCell>
    </GridRowContainer>
  );
});
